const IAB_CONFIG = {
  iabVersion: 'IAB_V2',
  categories: [
    {
      id: '1',
      name: 'Automotive',
      highlight: true,
      categories: [
        {
          id: '1.1',
          name: 'Auto Body Styles',
          categories: [
            {
              id: '1.1.1',
              name: 'Commercial Trucks',
              highlight: true,
            },
            {
              id: '1.1.2',
              name: 'Convertible',
              highlight: true,
            },
            {
              id: '1.1.3',
              name: 'Coupe',
              highlight: true,
            },
            {
              id: '1.1.4',
              name: 'Crossover',
              highlight: true,
            },
            {
              id: '1.1.5',
              name: 'Hatchback',
              highlight: true,
            },
            {
              id: '1.1.6',
              name: 'Microcar',
              highlight: true,
            },
            {
              id: '1.1.7',
              name: 'Minivan',
              highlight: true,
            },
            {
              id: '1.1.8',
              name: 'Off-Road Vehicles',
              highlight: true,
            },
            {
              id: '1.1.9',
              name: 'Pickup Trucks',
              highlight: true,
            },
            {
              id: '1.1.10',
              name: 'Sedan',
              highlight: true,
            },
            {
              id: '1.1.11',
              name: 'Station Wagon',
              highlight: true,
            },
            {
              id: '1.1.12',
              name: 'SUV',
              highlight: true,
            },
            {
              id: '1.1.13',
              name: 'Van',
              highlight: true,
            },
          ],
        },
        {
          id: '1.2',
          name: 'Auto Buying and Selling',
        },
        {
          id: '1.3',
          name: 'Auto Insurance',
        },
        {
          id: '1.4',
          name: 'Auto Parts',
        },
        {
          id: '1.5',
          name: 'Auto Recalls',
        },
        {
          id: '1.6',
          name: 'Auto Repair',
        },
        {
          id: '1.7',
          name: 'Auto Safety',
        },
        {
          id: '1.8',
          name: 'Auto Shows',
        },
        {
          id: '1.9',
          name: 'Auto Technology',
          categories: [
            {
              id: '1.9.1',
              name: 'Auto Infotainment Technologies',
            },
            {
              id: '1.9.2',
              name: 'Auto Navigation Systems',
            },
            {
              id: '1.9.3',
              name: 'Auto Safety Technologies',
            },
          ],
        },
        {
          id: '1.10',
          name: 'Auto Type',
          categories: [
            {
              id: '1.10.1',
              name: 'Budget Cars',
            },
            {
              id: '1.10.2',
              name: 'Certified Pre-Owned Cars',
            },
            {
              id: '1.10.3',
              name: 'Classic Cars',
            },
            {
              id: '1.10.4',
              name: 'Concept Cars',
            },
            {
              id: '1.10.5',
              name: 'Driverless Cars',
            },
            {
              id: '1.10.6',
              name: 'Green Vehicles',
            },
          ],
        },
        {
          id: '1.11',
          name: 'Car Culture',
        },
        {
          id: '1.12',
          name: 'Dash Cam Videos',
        },
        {
          id: '1.13',
          name: 'Motorcycles',
        },
        {
          id: '1.14',
          name: 'Road-Side Assistance',
        },
        {
          id: '1.15',
          name: 'Scooters',
        },
      ],
    },
    {
      id: '2',
      name: 'Books and Literature',
      categories: [
        {
          id: '2.1',
          name: 'Art and Photography Books',
        },
        {
          id: '2.2',
          name: 'Biographies',
        },
        {
          id: '2.3',
          name: "Children's Literature",
        },
        {
          id: '2.4',
          name: 'Comics and Graphic Novels',
        },
        {
          id: '2.5',
          name: 'Cookbooks',
        },
        {
          id: '2.6',
          name: 'Fiction',
        },
        {
          id: '2.7',
          name: 'Poetry',
        },
        {
          id: '2.8',
          name: 'Travel Books',
        },
        {
          id: '2.9',
          name: 'Young Adult Literature',
        },
      ],
    },
    {
      id: '3',
      name: 'Business and Finance',
      highlight: true,
      categories: [
        {
          id: '3.1',
          name: 'Business',
          highlight: true,
          categories: [
            {
              id: '3.1.1',
              name: 'Business Accounting & Finance',
            },
            {
              id: '3.1.2',
              name: 'Business Administration',
            },
            {
              id: '3.1.3',
              name: 'Business Banking & Finance',
              categories: [
                {
                  id: '3.1.3.1',
                  name: 'Angel Investment',
                },
                {
                  id: '3.1.3.2',
                  name: 'Bankruptcy',
                },
                {
                  id: '3.1.3.3',
                  name: 'Business Loans',
                },
                {
                  id: '3.1.3.4',
                  name: 'Debt Factoring & Invoice Discounting',
                },
                {
                  id: '3.1.3.5',
                  name: 'Mergers and Acquisitions',
                },
                {
                  id: '3.1.3.6',
                  name: 'Private Equity',
                },
                {
                  id: '3.1.3.7',
                  name: 'Sale & Lease Back',
                },
                {
                  id: '3.1.3.8',
                  name: 'Venture Capital',
                },
              ],
            },
            {
              id: '3.1.4',
              name: 'Business I.T.',
            },
            {
              id: '3.1.5',
              name: 'Business Operations',
            },
            {
              id: '3.1.6',
              name: 'Consumer Issues',
              categories: [
                {
                  id: '3.1.6.1',
                  name: 'Recalls',
                },
              ],
            },
            {
              id: '3.1.7',
              name: 'Executive Leadership & Management',
            },
            {
              id: '3.1.8',
              name: 'Government Business',
            },
            {
              id: '3.1.9',
              name: 'Green Solutions',
            },
            {
              id: '3.1.10',
              name: 'Human Resources',
            },
            {
              id: '3.1.11',
              name: 'Large Business',
            },
            {
              id: '3.1.12',
              name: 'Logistics',
            },
            {
              id: '3.1.13',
              name: 'Marketing and Advertising',
            },
            {
              id: '3.1.14',
              name: 'Sales',
            },
            {
              id: '3.1.15',
              name: 'Small and Medium-sized Business',
            },
            {
              id: '3.1.16',
              name: 'Startups',
            },
          ],
        },
        {
          id: '3.2',
          name: 'Economy',
          highlight: true,
          categories: [
            {
              id: '3.2.1',
              name: 'Commodities',
            },
            {
              id: '3.2.2',
              name: 'Currencies',
            },
            {
              id: '3.2.3',
              name: 'Financial Crisis',
            },
            {
              id: '3.2.4',
              name: 'Financial Reform',
            },
            {
              id: '3.2.5',
              name: 'Financial Regulation',
            },
            {
              id: '3.2.6',
              name: 'Gasoline Prices',
            },
            {
              id: '3.2.7',
              name: 'Housing Market',
            },
            {
              id: '3.2.8',
              name: 'Interest Rates',
            },
            {
              id: '3.2.9',
              name: 'Job Market',
            },
          ],
        },
        {
          id: '3.3',
          name: 'Industries',
          highlight: true,
          categories: [
            {
              id: '3.3.1',
              name: 'Advertising Industry',
            },
            {
              id: '3.3.2',
              name: 'Agriculture',
              highlight: true,
            },
            {
              id: '3.3.3',
              name: 'Apparel Industry',
            },
            {
              id: '3.3.4',
              name: 'Automotive Industry',
              highlight: true,
            },
            {
              id: '3.3.5',
              name: 'Aviation Industry',
            },
            {
              id: '3.3.6',
              name: 'Biotech and Biomedical Industry',
            },
            {
              id: '3.3.7',
              name: 'Civil Engineering Industry',
            },
            {
              id: '3.3.8',
              name: 'Construction Industry',
            },
            {
              id: '3.3.9',
              name: 'Defense Industry',
            },
            {
              id: '3.3.10',
              name: 'Education industry',
            },
            {
              id: '3.3.11',
              name: 'Entertainment Industry',
              highlight: true,
            },
            {
              id: '3.3.12',
              name: 'Environmental Services Industry',
            },
            {
              id: '3.3.13',
              name: 'Financial Industry',
            },
            {
              id: '3.3.14',
              name: 'Food Industry',
            },
            {
              id: '3.3.15',
              name: 'Healthcare Industry',
            },
            {
              id: '3.3.16',
              name: 'Hospitality Industry',
            },
            {
              id: '3.3.17',
              name: 'Information Services Industry',
            },
            {
              id: '3.3.18',
              name: 'Legal Services Industry',
            },
            {
              id: '3.3.19',
              name: 'Logistics and Transportation Industry',
            },
            {
              id: '3.3.20',
              name: 'Management Consulting Industry',
            },
            {
              id: '3.3.21',
              name: 'Manufacturing Industry',
            },
            {
              id: '3.3.22',
              name: 'Mechanical and Industrial Engineering Industry',
            },
            {
              id: '3.3.23',
              name: 'Media Industry',
              highlight: true,
            },
            {
              id: '3.3.24',
              name: 'Metals Industry',
            },
            {
              id: '3.3.25',
              name: 'Non-Profit Organizations',
            },
            {
              id: '3.3.26',
              name: 'Pharmaceutical Industry',
            },
            {
              id: '3.3.27',
              name: 'Power and Energy Industry',
            },
            {
              id: '3.3.28',
              name: 'Publishing Industry',
            },
            {
              id: '3.3.29',
              name: 'Real Estate Industry',
            },
            {
              id: '3.3.30',
              name: 'Retail Industry',
              highlight: true,
            },
            {
              id: '3.3.31',
              name: 'Technology Industry',
              highlight: true,
            },
            {
              id: '3.3.32',
              name: 'Telecommunications Industry',
            },
          ],
        },
      ],
    },
    {
      id: '4',
      name: 'Careers',
      categories: [
        {
          id: '4.1',
          name: 'Apprenticeships',
        },
        {
          id: '4.2',
          name: 'Career Advice',
        },
        {
          id: '4.3',
          name: 'Career Planning',
        },
        {
          id: '4.4',
          name: 'Job Search',
          categories: [
            {
              id: '4.4.1',
              name: 'Job Fairs',
            },
            {
              id: '4.4.2',
              name: 'Resume Writing and Advice',
            },
          ],
        },
        {
          id: '4.5',
          name: 'Telecommuting',
        },
        {
          id: '4.6',
          name: 'Vocational Training',
        },
      ],
    },
    {
      id: '5',
      name: 'Education',
      categories: [
        {
          id: '5.1',
          name: 'Adult Education',
        },
        {
          id: '5.2',
          name: 'College Education',
          categories: [
            {
              id: '5.2.1',
              name: 'College Planning',
            },
            {
              id: '5.2.2',
              name: 'Postgraduate Education',
              categories: [
                {
                  id: '5.2.2.1',
                  name: 'Professional School',
                },
              ],
            },
            {
              id: '5.2.3',
              name: 'Undergraduate Education',
            },
          ],
        },
        {
          id: '5.3',
          name: 'Early Childhood Education',
        },
        {
          id: '5.4',
          name: 'Educational Assessment',
          categories: [
            {
              id: '5.4.1',
              name: 'Standardized Testing',
            },
          ],
        },
        {
          id: '5.5',
          name: 'Homeschooling',
        },
        {
          id: '5.6',
          name: 'Homework and Study',
        },
        {
          id: '5.7',
          name: 'Language Learning',
        },
        {
          id: '5.8',
          name: 'Online Education',
        },
        {
          id: '5.9',
          name: 'Primary Education',
        },
        {
          id: '5.10',
          name: 'Private School',
        },
        {
          id: '5.11',
          name: 'Secondary Education',
        },
        {
          id: '5.12',
          name: 'Special Education',
        },
      ],
    },
    {
      id: '6',
      name: 'Events and Attractions',
      highlight: true,
      categories: [
        {
          id: '6.1',
          name: 'Amusement and Theme Parks',
          highlight: true,
        },
        {
          id: '6.2',
          name: 'Awards Shows',
          highlight: true,
        },
        {
          id: '6.3',
          name: 'Bars & Restaurants',
        },
        {
          id: '6.4',
          name: 'Business Expos & Conferences',
        },
        {
          id: '6.5',
          name: 'Casinos & Gambling',
        },
        {
          id: '6.6',
          name: 'Cinemas and Events',
        },
        {
          id: '6.7',
          name: 'Comedy Events',
        },
        {
          id: '6.8',
          name: 'Concerts & Music Events',
        },
        {
          id: '6.9',
          name: 'Fan Conventions',
        },
        {
          id: '6.10',
          name: 'Fashion Events',
          highlight: true,
        },
        {
          id: '6.11',
          name: 'Historic Site and Landmark Tours',
          highlight: true,
        },
        {
          id: '6.12',
          name: 'Malls & Shopping Centers',
          highlight: true,
        },
        {
          id: '6.13',
          name: 'Museums & Galleries',
          highlight: true,
        },
        {
          id: '6.14',
          name: 'Musicals',
          highlight: true,
        },
        {
          id: '6.15',
          name: 'National & Civic Holidays',
          highlight: true,
        },
        {
          id: '6.16',
          name: 'Nightclubs',
          highlight: true,
        },
        {
          id: '6.17',
          name: 'Outdoor Activities',
          highlight: true,
        },
        {
          id: '6.18',
          name: 'Parks & Nature',
          highlight: true,
        },
        {
          id: '6.19',
          name: 'Party Supplies and Decorations',
          highlight: true,
        },
        {
          id: '6.20',
          name: 'Personal Celebrations & Life Events',
          categories: [
            {
              id: '6.20.1',
              name: 'Anniversary',
            },
            {
              id: '6.20.2',
              name: 'Baby Shower',
            },
            {
              id: '6.20.3',
              name: 'Bachelor Party',
            },
            {
              id: '6.20.4',
              name: 'Bachelorette Party',
            },
            {
              id: '6.20.5',
              name: 'Birth',
            },
            {
              id: '6.20.6',
              name: 'Birthday',
            },
            {
              id: '6.20.7',
              name: 'Funeral',
            },
            {
              id: '6.20.8',
              name: 'Graduation',
            },
            {
              id: '6.20.9',
              name: 'Prom',
            },
            {
              id: '6.20.10',
              name: 'Wedding',
            },
          ],
        },
        {
          id: '6.21',
          name: 'Political Event',
        },
        {
          id: '6.22',
          name: 'Religious Events',
        },
        {
          id: '6.23',
          name: 'Sporting Events',
        },
        {
          id: '6.24',
          name: 'Theater Venues and Events',
        },
        {
          id: '6.25',
          name: 'Zoos & Aquariums',
        },
      ],
    },
    {
      id: '7',
      name: 'Family and Relationships',
      highlight: true,
      categories: [
        {
          id: '7.1',
          name: 'Bereavement',
        },
        {
          id: '7.2',
          name: 'Dating',
        },
        {
          id: '7.3',
          name: 'Divorce',
        },
        {
          id: '7.4',
          name: 'Eldercare',
        },
        {
          id: '7.5',
          name: 'Marriage and Civil Unions',
        },
        {
          id: '7.6',
          name: 'Parenting',
          categories: [
            {
              id: '7.6.1',
              name: 'Adoption and Fostering',
            },
            {
              id: '7.6.2',
              name: 'Daycare and Pre-School',
            },
            {
              id: '7.6.3',
              name: 'Internet Safety',
            },
            {
              id: '7.6.4',
              name: 'Parenting Babies and Toddlers',
            },
            {
              id: '7.6.5',
              name: 'Parenting Children Aged 4-11',
            },
            {
              id: '7.6.6',
              name: 'Parenting Teens',
            },
            {
              id: '7.6.7',
              name: 'Pregnancy',
            },
            {
              id: '7.6.8',
              name: 'Special Needs Kids',
            },
          ],
        },
        {
          id: '7.7',
          name: 'Single Life',
        },
      ],
    },
    {
      id: '8',
      name: 'Fine Art',
      categories: [
        {
          id: '8.1',
          name: 'Costume',
        },
        {
          id: '8.2',
          name: 'Dance',
        },
        {
          id: '8.3',
          name: 'Design',
        },
        {
          id: '8.4',
          name: 'Digital Arts',
        },
        {
          id: '8.6',
          name: 'Fine Art Photography',
        },
        {
          id: '8.7',
          name: 'Modern Art',
        },
        {
          id: '8.8',
          name: 'Opera',
        },
        {
          id: '8.9',
          name: 'Theater',
        },
      ],
    },
    {
      id: '9',
      name: 'Food & Drink',
      highlight: true,
      categories: [
        {
          id: '9.1',
          name: 'Alcoholic Beverages',
        },
        {
          id: '9.2',
          name: 'Barbecues and Grilling',
        },
        {
          id: '9.3',
          name: 'Cooking',
        },
        {
          id: '9.4',
          name: 'Desserts and Baking',
        },
        {
          id: '9.5',
          name: 'Dining Out',
        },
        {
          id: '9.6',
          name: 'Food Allergies',
        },
        {
          id: '9.7',
          name: 'Food Movements',
        },
        {
          id: '9.8',
          name: 'Healthy Cooking and Eating',
        },
        {
          id: '9.9',
          name: 'Non-Alcoholic Beverages',
        },
        {
          id: '9.10',
          name: 'Vegan Diets',
        },
        {
          id: '9.11',
          name: 'Vegetarian Diets',
        },
        {
          id: '9.12',
          name: 'World Cuisines',
        },
      ],
    },
    {
      id: '10',
      name: 'Healthy Living',
      highlight: true,
      categories: [
        {
          id: '10.1',
          name: "Children's Health",
        },
        {
          id: '10.2',
          name: 'Fitness and Exercise',
          categories: [
            {
              id: '10.2.1',
              name: 'Participant Sports',
            },
            {
              id: '10.2.2',
              name: 'Running and Jogging',
            },
          ],
        },
        {
          id: '10.3',
          name: "Men's Health",
        },
        {
          id: '10.4',
          name: 'Nutrition',
        },
        {
          id: '10.5',
          name: 'Senior Health',
        },
        {
          id: '10.6',
          name: 'Weight Loss',
        },
        {
          id: '10.7',
          name: 'Wellness',
          categories: [
            {
              id: '10.7.1',
              name: 'Alternative Medicine',
            },
            {
              id: '10.7.2',
              name: 'Physical Therapy',
            },
            {
              id: '10.7.3',
              name: 'Smoking Cessation',
            },
          ],
        },
        {
          id: '10.8',
          name: "Women's Health",
        },
      ],
    },
    {
      id: '11',
      name: 'Hobbies & Interests',
      highlight: true,
      categories: [
        {
          id: '11.1',
          name: 'Antiquing and Antiques',
        },
        {
          id: '11.2',
          name: 'Arts and Crafts',
          categories: [
            {
              id: '11.2.1',
              name: 'Beadwork',
            },
            {
              id: '11.2.2',
              name: 'Candle and Soap Making',
            },
            {
              id: '11.2.3',
              name: 'Drawing and Sketching',
            },
            {
              id: '11.2.4',
              name: 'Jewelry Making',
            },
            {
              id: '11.2.5',
              name: 'Needlework',
            },
            {
              id: '11.2.6',
              name: 'Painting',
            },
            {
              id: '11.2.7',
              name: 'Photography',
            },
            {
              id: '11.2.8',
              name: 'Scrapbooking',
            },
            {
              id: '11.2.9',
              name: 'Woodworking',
            },
          ],
        },
        {
          id: '11.3',
          name: 'Beekeeping',
        },
        {
          id: '11.4',
          name: 'Birdwatching',
        },
        {
          id: '11.5',
          name: 'Cigars',
        },
        {
          id: '11.6',
          name: 'Collecting',
          categories: [
            {
              id: '11.6.1',
              name: 'Comic Books',
            },
            {
              id: '11.6.2',
              name: 'Stamps and Coins',
            },
          ],
        },
        {
          id: '11.7',
          name: 'Content Production',
          categories: [
            {
              id: '11.7.1',
              name: 'Audio Production',
            },
            {
              id: '11.7.2',
              name: 'Freelance Writing',
            },
            {
              id: '11.7.3',
              name: 'Screenwriting',
            },
            {
              id: '11.7.4',
              name: 'Video Production',
            },
          ],
        },
        {
          id: '11.8',
          name: 'Games and Puzzles',
          categories: [
            {
              id: '11.8.1',
              name: 'Board Games and Puzzles',
            },
            {
              id: '11.8.2',
              name: 'Card Games',
            },
            {
              id: '11.8.3',
              name: 'Roleplaying Games',
            },
          ],
        },
        {
          id: '11.9',
          name: 'Genealogy and Ancestry',
        },
        {
          id: '11.10',
          name: 'Magic and Illusion',
        },
        {
          id: '11.11',
          name: 'Model Toys',
        },
        {
          id: '11.12',
          name: 'Musical Instruments',
        },
        {
          id: '11.13',
          name: 'Paranormal Phenomena',
        },
        {
          id: '11.14',
          name: 'Radio Control',
        },
        {
          id: '11.15',
          name: 'Sci-fi and Fantasy',
        },
        {
          id: '11.16',
          name: 'Workshops and Classes',
        },
      ],
    },
    {
      id: '12',
      name: 'Home & Garden',
      categories: [
        {
          id: '12.1',
          name: 'Gardening',
        },
        {
          id: '12.2',
          name: 'Home Appliances',
        },
        {
          id: '12.3',
          name: 'Home Entertaining',
        },
        {
          id: '12.4',
          name: 'Home Improvement',
        },
        {
          id: '12.5',
          name: 'Home Security',
        },
        {
          id: '12.6',
          name: 'Indoor Environmental Quality',
        },
        {
          id: '12.7',
          name: 'Interior Decorating',
        },
        {
          id: '12.8',
          name: 'Landscaping',
        },
        {
          id: '12.9',
          name: 'Outdoor Decorating',
        },
        {
          id: '12.10',
          name: 'Remodeling & Construction',
        },
        {
          id: '12.11',
          name: 'Smart Home',
        },
      ],
    },
    {
      id: '13',
      name: 'Medical Health',
      highlight: true,
      categories: [
        {
          id: '13.1',
          name: 'Diseases and Conditions',
          highlight: true,
          categories: [
            {
              id: '13.1.1',
              name: 'Allergies',
            },
            {
              id: '13.1.2',
              name: 'Blood Disorders',
            },
            {
              id: '13.1.3',
              name: 'Bone and Joint Conditions',
            },
            {
              id: '13.1.4',
              name: 'Brain and Nervous System Disorders',
            },
            {
              id: '13.1.5',
              name: 'Cancer',
            },
            {
              id: '13.1.6',
              name: 'Cold and Flu',
            },
            {
              id: '13.1.7',
              name: 'Dental Health',
            },
            {
              id: '13.1.8',
              name: 'Diabetes',
            },
            {
              id: '13.1.9',
              name: 'Digestive Disorders',
            },
            {
              id: '13.1.10',
              name: 'Ear, Nose and Throat Conditions',
            },
            {
              id: '13.1.11',
              name: 'Endocrine and Metabolic Diseases',
              categories: [
                {
                  id: '13.1.11.1',
                  name: 'Hormonal Disorders',
                },
                {
                  id: '13.1.11.2',
                  name: 'Menopause',
                },
                {
                  id: '13.1.11.3',
                  name: 'Thyroid Disorders',
                },
              ],
            },
            {
              id: '13.1.12',
              name: 'Eye and Vision Conditions',
            },
            {
              id: '13.1.13',
              name: 'Foot Health',
            },
            {
              id: '13.1.14',
              name: 'Heart and Cardiovascular Diseases',
            },
            {
              id: '13.1.15',
              name: 'Infectious Diseases',
              highlight: true,
            },
            {
              id: '13.1.16',
              name: 'Injuries',
              categories: [
                {
                  id: '13.1.16.1',
                  name: 'First Aid',
                },
              ],
            },
            {
              id: '13.1.17',
              name: 'Lung and Respiratory Health',
            },
            {
              id: '13.1.18',
              name: 'Mental Health',
            },
            {
              id: '13.1.19',
              name: 'Reproductive Health',
              categories: [
                {
                  id: '13.1.19.1',
                  name: 'Birth Control',
                },
                {
                  id: '13.1.19.2',
                  name: 'Infertility',
                },
                {
                  id: '13.1.19.3',
                  name: 'Pregnancy',
                },
              ],
            },
            {
              id: '13.1.20',
              name: 'Sexual Health',
              categories: [
                {
                  id: '13.1.20.1',
                  name: 'Sexual Conditions',
                },
              ],
            },
            {
              id: '13.1.21',
              name: 'Skin and Dermatology',
            },
            {
              id: '13.1.22',
              name: 'Sleep Disorders',
            },
            {
              id: '13.1.23',
              name: 'Substance Abuse',
            },
          ],
        },
        {
          id: '13.2',
          name: 'Medical Tests',
        },
        {
          id: '13.3',
          name: 'Pharmaceutical Drugs',
        },
        {
          id: '13.4',
          name: 'Surgery',
        },
        {
          id: '13.5',
          name: 'Vaccines',
        },
      ],
    },
    {
      id: '14',
      name: 'Movies',
      highlight: true,
      categories: [
        {
          id: '14.1',
          name: 'Action and Adventure Movies',
        },
        {
          id: '14.2',
          name: 'Animation Movies',
        },
        {
          id: '14.3',
          name: 'Comedy Movies',
        },
        {
          id: '14.4',
          name: 'Crime and Mystery Movies',
        },
        {
          id: '14.5',
          name: 'Documentary Movies',
        },
        {
          id: '14.6',
          name: 'Drama Movies',
        },
        {
          id: '14.7',
          name: 'Family and Children Movies',
        },
        {
          id: '14.8',
          name: 'Fantasy Movies',
        },
        {
          id: '14.9',
          name: 'Horror Movies',
        },
        {
          id: '14.10',
          name: 'Romance Movies',
        },
        {
          id: '14.11',
          name: 'Science Fiction Movies',
        },
        {
          id: '14.12',
          name: 'Special Interest Movies',
        },
      ],
    },
    {
      id: '15',
      name: 'Music and Audio',
      highlight: true,
      categories: [
        {
          id: '15.1',
          name: 'Adult Contemporary Music',
        },
        {
          id: '15.2',
          name: 'Arts Podcasts',
        },
        {
          id: '15.3',
          name: 'Blues',
        },
        {
          id: '15.4',
          name: 'Business News Radio',
        },
        {
          id: '15.5',
          name: 'Business Podcasts',
        },
        {
          id: '15.6',
          name: "Children's Music",
        },
        {
          id: '15.7',
          name: 'Classic Hits',
        },
        {
          id: '15.8',
          name: 'Classical Music',
        },
        {
          id: '15.9',
          name: 'College Radio',
        },
        {
          id: '15.10',
          name: 'Comedy Podcasts',
        },
        {
          id: '15.11',
          name: 'Comedy Radio',
        },
        {
          id: '15.12',
          name: 'Contemporary Hits',
        },
        {
          id: '15.13',
          name: 'Country Music',
        },
        {
          id: '15.14',
          name: 'Dance and Electronic Music',
        },
        {
          id: '15.15',
          name: 'Education Podcasts',
        },
        {
          id: '15.16',
          name: 'Folk Music',
        },
        {
          id: '15.17',
          name: 'Games & Hobbies Podcasts',
        },
        {
          id: '15.18',
          name: 'Gospel Music',
        },
        {
          id: '15.19',
          name: 'Health Podcasts',
        },
        {
          id: '15.20',
          name: 'Hip Hop Music',
        },
        {
          id: '15.21',
          name: 'Inspirational Music',
        },
        {
          id: '15.22',
          name: 'International Music',
        },
        {
          id: '15.23',
          name: 'Jazz',
        },
        {
          id: '15.24',
          name: 'Kids & Family Podcasts',
        },
        {
          id: '15.25',
          name: 'News & Politics Podcasts',
        },
        {
          id: '15.26',
          name: 'Oldies Music',
        },
        {
          id: '15.27',
          name: 'Public Radio',
        },
        {
          id: '15.28',
          name: 'Reggae',
        },
        {
          id: '15.29',
          name: 'Religion & Spirituality Podcasts',
        },
        {
          id: '15.30',
          name: 'Religious Music',
        },
        {
          id: '15.31',
          name: 'Rhythm and Blues',
        },
        {
          id: '15.32',
          name: 'Rock Music',
          categories: [
            {
              id: '15.32.1',
              name: 'Album-oriented Rock',
            },
            {
              id: '15.32.2',
              name: 'Alternative Rock',
            },
            {
              id: '15.32.3',
              name: 'Classic Rock',
            },
            {
              id: '15.32.4',
              name: 'Hard Rock',
            },
          ],
        },
        {
          id: '15.33',
          name: 'Science & Medicine Podcasts',
        },
        {
          id: '15.34',
          name: 'Society & Culture Podcasts',
        },
        {
          id: '15.35',
          name: 'Soundtracks',
        },
        {
          id: '15.36',
          name: 'Sports & Recreation Podcasts',
        },
        {
          id: '15.37',
          name: 'Sports Play-by-Play',
        },
        {
          id: '15.38',
          name: 'Sports Talk Radio',
        },
        {
          id: '15.39',
          name: 'Talk Radio',
          categories: [
            {
              id: '15.39.1',
              name: 'All-news radio',
            },
            {
              id: '15.39.2',
              name: 'Educational Radio',
            },
            {
              id: '15.39.3',
              name: 'News/Talk',
            },
          ],
        },
        {
          id: '15.40',
          name: 'Technology Podcasts',
        },
        {
          id: '15.41',
          name: 'TV & Film Podcasts',
        },
        {
          id: '15.42',
          name: 'Urban Adult Contemporary Music',
        },
        {
          id: '15.43',
          name: 'Urban Contemporary Music',
        },
      ],
    },
    {
      id: '16',
      name: 'News and Politics',
      highlight: true,
      categories: [
        {
          id: '16.1',
          name: 'Crime',
          highlight: true,
        },
        {
          id: '16.2',
          name: 'Disasters',
          highlight: true,
        },
        {
          id: '16.3',
          name: 'International News',
        },
        {
          id: '16.4',
          name: 'Law',
        },
        {
          id: '16.5',
          name: 'Local News',
        },
        {
          id: '16.6',
          name: 'National News',
        },
        {
          id: '16.7',
          name: 'Politics',
          highlight: true,
          categories: [
            {
              id: '16.7.1',
              name: 'Elections',
            },
            {
              id: '16.7.2',
              name: 'Political Issues',
            },
            {
              id: '16.7.3',
              name: 'War and Conflicts',
              highlight: true,
            },
          ],
        },
        {
          id: '16.8',
          name: 'Weather',
        },
      ],
    },
    {
      id: '17',
      name: 'Personal Finance',
      categories: [
        {
          id: '17.1',
          name: 'Consumer Banking',
        },
        {
          id: '17.2',
          name: 'Financial Assistance',
          categories: [
            {
              id: '17.2.1',
              name: 'Government Support and Welfare',
            },
            {
              id: '17.2.2',
              name: 'Student Financial Aid',
            },
          ],
        },
        {
          id: '17.3',
          name: 'Financial Planning',
        },
        {
          id: '17.4',
          name: 'Frugal Living',
        },
        {
          id: '17.5',
          name: 'Insurance',
          categories: [
            {
              id: '17.5.1',
              name: 'Health Insurance',
            },
            {
              id: '17.5.2',
              name: 'Home Insurance',
            },
            {
              id: '17.5.3',
              name: 'Life Insurance',
            },
            {
              id: '17.5.4',
              name: 'Motor Insurance',
            },
            {
              id: '17.5.5',
              name: 'Pet Insurance',
            },
            {
              id: '17.5.6',
              name: 'Travel Insurance',
            },
          ],
        },
        {
          id: '17.6',
          name: 'Personal Debt',
          categories: [
            {
              id: '17.6.1',
              name: 'Credit Cards',
            },
            {
              id: '17.6.2',
              name: 'Home Financing',
            },
            {
              id: '17.6.3',
              name: 'Personal Loans',
            },
            {
              id: '17.6.4',
              name: 'Student Loans',
            },
          ],
        },
        {
          id: '17.7',
          name: 'Personal Investing',
          categories: [
            {
              id: '17.7.1',
              name: 'Hedge Funds',
            },
            {
              id: '17.7.2',
              name: 'Mutual Funds',
            },
            {
              id: '17.7.3',
              name: 'Options',
            },
            {
              id: '17.7.4',
              name: 'Stocks and Bonds',
            },
          ],
        },
        {
          id: '17.8',
          name: 'Personal Taxes',
        },
        {
          id: '17.9',
          name: 'Retirement Planning',
        },
      ],
    },
    {
      id: '18',
      name: 'Pets',
      categories: [
        {
          id: '18.1',
          name: 'Birds',
        },
        {
          id: '18.2',
          name: 'Cats',
        },
        {
          id: '18.3',
          name: 'Dogs',
        },
        {
          id: '18.4',
          name: 'Fish and Aquariums',
        },
        {
          id: '18.5',
          name: 'Large Animals',
        },
        {
          id: '18.6',
          name: 'Pet Adoptions',
        },
        {
          id: '18.7',
          name: 'Reptiles',
        },
        {
          id: '18.8',
          name: 'Veterinary Medicine',
        },
      ],
    },
    {
      id: '19',
      name: 'Pop Culture',
      highlight: true,
      categories: [
        {
          id: '19.1',
          name: 'Celebrity Deaths',
          highlight: true,
        },
        {
          id: '19.2',
          name: 'Celebrity Families',
          highlight: true,
        },
        {
          id: '19.3',
          name: 'Celebrity Homes',
          highlight: true,
        },
        {
          id: '19.4',
          name: 'Celebrity Pregnancy',
          highlight: true,
        },
        {
          id: '19.5',
          name: 'Celebrity Relationships',
          highlight: true,
        },
        {
          id: '19.6',
          name: 'Celebrity Scandal',
          highlight: true,
        },
        {
          id: '19.7',
          name: 'Celebrity Style',
          highlight: true,
        },
      ],
    },
    {
      id: '20',
      name: 'Real Estate',
      categories: [
        {
          id: '20.1',
          name: 'Apartments',
        },
        {
          id: '20.2',
          name: 'Developmental Sites',
        },
        {
          id: '20.3',
          name: 'Hotel Properties',
        },
        {
          id: '20.4',
          name: 'Houses',
        },
        {
          id: '20.5',
          name: 'Industrial Property',
        },
        {
          id: '20.6',
          name: 'Land and Farms',
        },
        {
          id: '20.7',
          name: 'Office Property',
        },
        {
          id: '20.8',
          name: 'Real Estate Buying and Selling',
        },
        {
          id: '20.9',
          name: 'Real Estate Renting and Leasing',
        },
        {
          id: '20.10',
          name: 'Retail Property',
        },
        {
          id: '20.11',
          name: 'Vacation Properties',
        },
      ],
    },
    {
      id: '21',
      name: 'Religion & Spirituality',
      categories: [
        {
          id: '21.1',
          name: 'Agnosticism',
        },
        {
          id: '21.2',
          name: 'Astrology',
        },
        {
          id: '21.3',
          name: 'Atheism',
        },
        {
          id: '21.4',
          name: 'Buddhism',
        },
        {
          id: '21.5',
          name: 'Christianity',
        },
        {
          id: '21.6',
          name: 'Hinduism',
        },
        {
          id: '21.7',
          name: 'Islam',
        },
        {
          id: '21.8',
          name: 'Judaism',
        },
        {
          id: '21.9',
          name: 'Sikhism',
        },
        {
          id: '21.10',
          name: 'Spirituality',
        },
      ],
    },
    {
      id: '22',
      name: 'Science',
      categories: [
        {
          id: '22.1',
          name: 'Biological Sciences',
        },
        {
          id: '22.2',
          name: 'Chemistry',
        },
        {
          id: '22.3',
          name: 'Environment',
        },
        {
          id: '22.4',
          name: 'Genetics',
        },
        {
          id: '22.5',
          name: 'Geography',
        },
        {
          id: '22.6',
          name: 'Geology',
        },
        {
          id: '22.7',
          name: 'Physics',
        },
        {
          id: '22.8',
          name: 'Space and Astronomy',
        },
      ],
    },
    {
      id: '23',
      name: 'Shopping',
      categories: [
        {
          id: '23.1',
          name: 'Couponing',
        },
      ],
    },
    {
      id: '24',
      name: 'Sports',
      highlight: true,
      categories: [
        {
          id: '24.1',
          name: 'American Football',
          highlight: true,
        },
        {
          id: '24.2',
          name: 'Australian Rules Football',
        },
        {
          id: '24.3',
          name: 'Auto Racing',
          categories: [
            {
              id: '24.3.1',
              name: 'Motorcycle Sports',
            },
          ],
        },
        {
          id: '24.4',
          name: 'Badminton',
        },
        {
          id: '24.5',
          name: 'Baseball',
          highlight: true,
        },
        {
          id: '24.6',
          name: 'Basketball',
          highlight: true,
        },
        {
          id: '24.7',
          name: 'Beach Volleyball',
        },
        {
          id: '24.8',
          name: 'Bodybuilding',
        },
        {
          id: '24.9',
          name: 'Bowling',
        },
        {
          id: '24.10',
          name: 'Boxing',
        },
        {
          id: '24.11',
          name: 'Cheerleading',
        },
        {
          id: '24.12',
          name: 'College Sports',
        },
        {
          id: '24.13',
          name: 'Cricket',
        },
        {
          id: '24.14',
          name: 'Cycling',
        },
        {
          id: '24.15',
          name: 'Darts',
        },
        {
          id: '24.16',
          name: 'Disabled Sports',
        },
        {
          id: '24.17',
          name: 'Diving',
        },
        {
          id: '24.18',
          name: 'Equine Sports',
          categories: [
            {
              id: '24.18.1',
              name: 'Horse Racing',
            },
          ],
        },
        {
          id: '24.19',
          name: 'Extreme Sports',
          categories: [
            {
              id: '24.19.1',
              name: 'Canoeing and Kayaking',
            },
            {
              id: '24.19.2',
              name: 'Climbing',
            },
            {
              id: '24.19.3',
              name: 'Paintball',
            },
            {
              id: '24.19.4',
              name: 'Scuba Diving',
            },
            {
              id: '24.19.5',
              name: 'Skateboarding',
            },
            {
              id: '24.19.6',
              name: 'Snowboarding',
            },
            {
              id: '24.19.7',
              name: 'Surfing and Bodyboarding',
            },
            {
              id: '24.19.8',
              name: 'Waterskiing and Wakeboarding',
            },
          ],
        },
        {
          id: '24.20',
          name: 'Fantasy Sports',
        },
        {
          id: '24.21',
          name: 'Field Hockey',
        },
        {
          id: '24.22',
          name: 'Figure Skating',
        },
        {
          id: '24.23',
          name: 'Fishing Sports',
        },
        {
          id: '24.24',
          name: 'Golf',
          highlight: true,
        },
        {
          id: '24.25',
          name: 'Gymnastics',
        },
        {
          id: '24.26',
          name: 'Hunting and Shooting',
        },
        {
          id: '24.27',
          name: 'Ice Hockey',
          highlight: true,
        },
        {
          id: '24.28',
          name: 'Inline Skating',
        },
        {
          id: '24.29',
          name: 'Lacrosse',
        },
        {
          id: '24.30',
          name: 'Martial Arts',
        },
        {
          id: '24.31',
          name: 'Olympic Sports',
          categories: [
            {
              id: '24.31.1',
              name: 'Summer Olympic Sports',
            },
            {
              id: '24.31.2',
              name: 'Winter Olympic Sports',
            },
          ],
        },
        {
          id: '24.32',
          name: 'Poker and Professional Gambling',
        },
        {
          id: '24.33',
          name: 'Rodeo',
        },
        {
          id: '24.34',
          name: 'Rowing',
        },
        {
          id: '24.35',
          name: 'Rugby',
          categories: [
            {
              id: '24.35.1',
              name: 'Rugby League',
            },
            {
              id: '24.35.2',
              name: 'Rugby Union',
            },
          ],
        },
        {
          id: '24.36',
          name: 'Sailing',
        },
        {
          id: '24.37',
          name: 'Skiing',
        },
        {
          id: '24.38',
          name: 'Snooker/Pool/Billiards',
        },
        {
          id: '24.39',
          name: 'Soccer',
          highlight: true,
        },
        {
          id: '24.40',
          name: 'Softball',
        },
        {
          id: '24.41',
          name: 'Squash',
        },
        {
          id: '24.42',
          name: 'Swimming',
        },
        {
          id: '24.43',
          name: 'Table Tennis',
        },
        {
          id: '24.44',
          name: 'Tennis',
        },
        {
          id: '24.45',
          name: 'Track and Field',
        },
        {
          id: '24.46',
          name: 'Volleyball',
        },
        {
          id: '24.47',
          name: 'Walking',
        },
        {
          id: '24.48',
          name: 'Water Polo',
        },
        {
          id: '24.49',
          name: 'Weightlifting',
        },
        {
          id: '24.50',
          name: 'Wrestling',
          highlight: true,
        },
      ],
    },
    {
      id: '25',
      name: 'Style & Fashion',
      highlight: true,
      categories: [
        {
          id: '25.1',
          name: 'Beauty',
          categories: [
            {
              id: '25.1.1',
              name: 'Hair Care',
            },
            {
              id: '25.1.2',
              name: 'Makeup and Accessories',
            },
            {
              id: '25.1.3',
              name: 'Nail Care',
            },
            {
              id: '25.1.4',
              name: 'Natural and Organic Beauty',
            },
            {
              id: '25.1.5',
              name: 'Perfume and Fragrance',
            },
            {
              id: '25.1.6',
              name: 'Skin Care',
            },
          ],
        },
        {
          id: '25.2',
          name: 'Body Art',
        },
        {
          id: '25.3',
          name: "Children's Clothing",
        },
        {
          id: '25.4',
          name: 'Designer Clothing',
        },
        {
          id: '25.5',
          name: 'Fashion Trends',
        },
        {
          id: '25.6',
          name: 'High Fashion',
        },
        {
          id: '25.7',
          name: "Men's Fashion",
          categories: [
            {
              id: '25.7.1',
              name: "Men's Accessories",
              categories: [
                {
                  id: '25.7.1.1',
                  name: "Men's Jewelry and Watches",
                },
              ],
            },
            {
              id: '25.7.2',
              name: "Men's Clothing",
              categories: [
                {
                  id: '25.7.2.1',
                  name: "Men's Business Wear",
                },
                {
                  id: '25.7.2.2',
                  name: "Men's Casual Wear",
                },
                {
                  id: '25.7.2.3',
                  name: "Men's Formal Wear",
                },
                {
                  id: '25.7.2.4',
                  name: "Men's Outerwear",
                },
                {
                  id: '25.7.2.5',
                  name: "Men's Sportswear",
                },
                {
                  id: '25.7.2.6',
                  name: "Men's Underwear and Sleepwear",
                },
              ],
            },
            {
              id: '25.7.3',
              name: "Men's Shoes and Footwear",
            },
          ],
        },
        {
          id: '25.8',
          name: 'Personal Care',
          categories: [
            {
              id: '25.8.1',
              name: 'Bath and Shower',
            },
            {
              id: '25.8.2',
              name: 'Deodorant and Antiperspirant',
            },
            {
              id: '25.8.3',
              name: 'Oral care',
            },
            {
              id: '25.8.4',
              name: 'Shaving',
            },
          ],
        },
        {
          id: '25.9',
          name: 'Street Style',
        },
        {
          id: '25.10',
          name: "Women's Fashion",
          categories: [
            {
              id: '25.10.1',
              name: "Women's Accessories",
              categories: [
                {
                  id: '25.10.1.1',
                  name: "Women's Glasses",
                },
                {
                  id: '25.10.1.2',
                  name: "Women's Handbags and Wallets",
                },
                {
                  id: '25.10.1.3',
                  name: "Women's Hats and Scarves",
                },
                {
                  id: '25.10.1.4',
                  name: "Women's Jewelry and Watches",
                },
              ],
            },
            {
              id: '25.10.2',
              name: "Women's Clothing",
              categories: [
                {
                  id: '25.10.2.1',
                  name: "Women's Business Wear",
                },
                {
                  id: '25.10.2.2',
                  name: "Women's Casual Wear",
                },
                {
                  id: '25.10.2.3',
                  name: "Women's Formal Wear",
                },
                {
                  id: '25.10.2.4',
                  name: "Women's Intimates and Sleepwear",
                },
                {
                  id: '25.10.2.5',
                  name: "Women's Outerwear",
                },
                {
                  id: '25.10.2.6',
                  name: "Women's Sportswear",
                },
              ],
            },
            {
              id: '25.10.3',
              name: "Women's Shoes and Footwear",
            },
          ],
        },
      ],
    },
    {
      id: '26',
      name: 'Technology & Computing',
      highlight: true,
      categories: [
        {
          id: '26.1',
          name: 'Artificial Intelligence',
        },
        {
          id: '26.2',
          name: 'Augmented Reality',
        },
        {
          id: '26.3',
          name: 'Computing',
          categories: [
            {
              id: '26.3.1',
              name: 'Computer Networking',
            },
            {
              id: '26.3.2',
              name: 'Computer Peripherals',
            },
            {
              id: '26.3.3',
              name: 'Computer Software and Applications',
              categories: [
                {
                  id: '26.3.3.1',
                  name: '3-D Graphics',
                },
                {
                  id: '26.3.3.2',
                  name: 'Antivirus Software',
                },
                {
                  id: '26.3.3.3',
                  name: 'Browsers',
                },
                {
                  id: '26.3.3.4',
                  name: 'Computer Animation',
                },
                {
                  id: '26.3.3.5',
                  name: 'Databases',
                },
                {
                  id: '26.3.3.6',
                  name: 'Desktop Publishing',
                },
                {
                  id: '26.3.3.7',
                  name: 'Digital Audio',
                },
                {
                  id: '26.3.3.8',
                  name: 'Graphics Software',
                },
                {
                  id: '26.3.3.9',
                  name: 'Operating Systems',
                },
                {
                  id: '26.3.3.10',
                  name: 'Photo Editing Software',
                },
                {
                  id: '26.3.3.11',
                  name: 'Shareware and Freeware',
                },
                {
                  id: '26.3.3.12',
                  name: 'Video Software',
                },
                {
                  id: '26.3.3.13',
                  name: 'Web Conferencing',
                },
              ],
            },
            {
              id: '26.3.4',
              name: 'Data Storage and Warehousing',
            },
            {
              id: '26.3.5',
              name: 'Desktops',
            },
            {
              id: '26.3.6',
              name: 'Information and Network Security',
            },
            {
              id: '26.3.7',
              name: 'Internet',
              highlight: true,
              categories: [
                {
                  id: '26.3.7.1',
                  name: 'Cloud Computing',
                },
                {
                  id: '26.3.7.2',
                  name: 'Email',
                },
                {
                  id: '26.3.7.3',
                  name: 'Internet for Beginners',
                },
                {
                  id: '26.3.7.4',
                  name: 'Internet of Things',
                },
                {
                  id: '26.3.7.5',
                  name: 'IT and Internet Support',
                },
                {
                  id: '26.3.7.6',
                  name: 'Search',
                },
                {
                  id: '26.3.7.7',
                  name: 'Social Networking',
                  highlight: true,
                },
                {
                  id: '26.3.7.8',
                  name: 'Web Conferencing',
                },
                {
                  id: '26.3.7.9',
                  name: 'Web Design and HTML',
                },
                {
                  id: '26.3.7.10',
                  name: 'Web Development',
                },
                {
                  id: '26.3.7.11',
                  name: 'Web Hosting',
                },
              ],
            },
            {
              id: '26.3.8',
              name: 'Laptops',
            },
            {
              id: '26.3.9',
              name: 'Programming Languages',
            },
          ],
        },
        {
          id: '26.4',
          name: 'Consumer Electronics',
          categories: [
            {
              id: '26.4.1',
              name: 'Cameras and Camcorders',
            },
            {
              id: '26.4.2',
              name: 'Home Entertainment Systems',
            },
            {
              id: '26.4.3',
              name: 'Smartphones',
            },
            {
              id: '26.4.4',
              name: 'Tablets and E-readers',
            },
            {
              id: '26.4.5',
              name: 'Wearable Technology',
            },
          ],
        },
        {
          id: '26.5',
          name: 'Robotics',
        },
        {
          id: '26.6',
          name: 'Virtual Reality',
        },
      ],
    },
    {
      id: '27',
      name: 'Television',
      highlight: true,
      categories: [
        {
          id: '27.1',
          name: 'Animation TV',
        },
        {
          id: '27.2',
          name: "Children's TV",
        },
        {
          id: '27.3',
          name: 'Comedy TV',
        },
        {
          id: '27.4',
          name: 'Drama TV',
        },
        {
          id: '27.5',
          name: 'Factual TV',
        },
        {
          id: '27.6',
          name: 'Holiday TV',
        },
        {
          id: '27.7',
          name: 'Music TV',
        },
        {
          id: '27.8',
          name: 'Reality TV',
        },
        {
          id: '27.9',
          name: 'Science Fiction TV',
        },
        {
          id: '27.10',
          name: 'Soap Opera TV',
        },
        {
          id: '27.11',
          name: 'Special Interest TV',
        },
        {
          id: '27.12',
          name: 'Sports TV',
        },
      ],
    },
    {
      id: '28',
      name: 'Travel',
      categories: [
        {
          id: '28.1',
          name: 'Travel Accessories',
        },
        {
          id: '28.2',
          name: 'Travel Locations',
          categories: [
            {
              id: '28.2.1',
              name: 'Africa Travel',
            },
            {
              id: '28.2.2',
              name: 'Asia Travel',
            },
            {
              id: '28.2.3',
              name: 'Australia and Oceania Travel',
            },
            {
              id: '28.2.4',
              name: 'Europe Travel',
            },
            {
              id: '28.2.5',
              name: 'North America Travel',
            },
            {
              id: '28.2.6',
              name: 'Polar Travel',
            },
            {
              id: '28.2.7',
              name: 'South America Travel',
            },
          ],
        },
        {
          id: '28.3',
          name: 'Travel Preparation',
        },
        {
          id: '28.4',
          name: 'Travel Type',
          categories: [
            {
              id: '28.4.1',
              name: 'Adventure Travel',
            },
            {
              id: '28.4.2',
              name: 'Air Travel',
            },
            {
              id: '28.4.3',
              name: 'Beach Travel',
            },
            {
              id: '28.4.4',
              name: 'Bed & Breakfasts',
            },
            {
              id: '28.4.5',
              name: 'Budget Travel',
            },
            {
              id: '28.4.6',
              name: 'Business Travel',
            },
            {
              id: '28.4.7',
              name: 'Camping',
            },
            {
              id: '28.4.8',
              name: 'Cruises',
            },
            {
              id: '28.4.9',
              name: 'Day Trips',
            },
            {
              id: '28.4.10',
              name: 'Family Travel',
            },
            {
              id: '28.4.11',
              name: 'Honeymoons and Getaways',
            },
            {
              id: '28.4.12',
              name: 'Hotels and Motels',
            },
            {
              id: '28.4.13',
              name: 'Rail Travel',
            },
            {
              id: '28.4.14',
              name: 'Road Trips',
            },
            {
              id: '28.4.15',
              name: 'Spas',
            },
          ],
        },
      ],
    },
    {
      id: '29',
      name: 'Video Gaming',
      highlight: true,
      categories: [
        {
          id: '29.1',
          name: 'Console Games',
        },
        {
          id: '29.2',
          name: 'eSports',
        },
        {
          id: '29.3',
          name: 'Mobile Games',
        },
        {
          id: '29.4',
          name: 'PC Games',
        },
        {
          id: '29.5',
          name: 'Video Game Genres',
          categories: [
            {
              id: '29.5.1',
              name: 'Action Video Games',
            },
            {
              id: '29.5.2',
              name: 'Action-Adventure Video Games',
            },
            {
              id: '29.5.3',
              name: 'Adventure Video Games',
            },
            {
              id: '29.5.4',
              name: 'Casual Games',
            },
            {
              id: '29.5.5',
              name: 'Educational Video Games',
            },
            {
              id: '29.5.6',
              name: 'Exercise and Fitness Video Games',
            },
            {
              id: '29.5.7',
              name: 'MMOs',
            },
            {
              id: '29.5.8',
              name: 'Music and Party Video Games',
            },
            {
              id: '29.5.9',
              name: 'Puzzle Video Games',
            },
            {
              id: '29.5.10',
              name: 'Role-Playing Video Games',
            },
            {
              id: '29.5.11',
              name: 'Simulation Video Games',
            },
            {
              id: '29.5.12',
              name: 'Sports Video Games',
            },
            {
              id: '29.5.13',
              name: 'Strategy Video Games',
            },
          ],
        },
      ],
    },
  ],
};

export const iab = IAB_CONFIG.categories;
